exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1bQneZ1buXvSgeJtqYlYiC{width:475px;height:600px}html[dir] ._3UeKM_mbl4AjUT8k7_ytLG{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"container": "_1bQneZ1buXvSgeJtqYlYiC",
	"fileProvidersToAddContainer": "_3UeKM_mbl4AjUT8k7_ytLG"
};